<section class="home-hero">
  <div class="hero-content">
    <p class="hero-eyebrow">Realtime Technical Assistance</p>
    <h1>How can we help?</h1>
    <p class="hero-subtitle">Search the real-time operations knowledge base and get support fast.</p>
    <form role="search" aria-label="Search knowledge base">
      <kendo-textbox size="large" class="hero-search-input" placeholder="Search articles, alerts, and workflows">
        <ng-template kendoTextBoxSuffixTemplate [showSeparator]="true">
          <kendo-svgicon [icon]="searchIcon"></kendo-svgicon>
        </ng-template>
      </kendo-textbox>
    </form>
  </div>
</section>

<div class="portal-container">
      <div class="cards-wrapper">
        <kendo-card *ngFor="let card of cards; let i = index"
                    [class.elevated]="i === 1"
                    class="support-card"
                    (click)="onCardClick(card)"
                    [style.cursor]="'pointer'">
          <kendo-card-body>
            <div class="card-content">
              <kendo-icon name="palette"></kendo-icon>
              <span class="k-icon k-font-icon {{card.icon}}"></span>
              <h3 class="card-title">{{ card.title }}</h3>
              <p class="card-description">{{ card.description }}</p>
            </div>
          </kendo-card-body>
        </kendo-card>
      </div>
    </div>
